import { render, staticRenderFns } from "./Models.vue?vue&type=template&id=f4747762&scoped=true"
import script from "./Models.vue?vue&type=script&lang=js"
export * from "./Models.vue?vue&type=script&lang=js"
import style0 from "./Models.vue?vue&type=style&index=0&id=f4747762&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4747762",
  null
  
)

export default component.exports